// extracted by mini-css-extract-plugin
module.exports = {"rail":"BaseDesktopRightRailAd_rail__AORkK","sticky":"BaseDesktopRightRailAd_sticky__2Kzc0","label":"BaseDesktopRightRailAd_label__TOG28"};